/* eslint-disable react-hooks/exhaustive-deps */
//#region Imports
import React, { useState, useEffect, useContext, useMemo } from "react"
import {
  getAirportSeasonConfigurations,
  getDmpRecords,
  setDmpRecords
} from "../../api/BackendCalls"
import { PageId } from "../../common/pageId"
import { AppContext } from "../../app/App"
import {
  BtnText,
  CommonText,
  FieldName,
  FlightText,
  LoadingText
} from "../../common/text"
import { getPageConfig } from "../Config"
import { PageTemplate } from "../../components/pageTemplate/PageTemplate"
import DropdownField, {
  ValueLabel
} from "../../components/generic/form/DropdownField"
import { DataEditTableGrid } from "../../components/table/DataEditTableGrid"
import { ColDef, ValueGetterParams } from "ag-grid-community"
import {
  formatDate,
  formatDateShortwYear,
  formatISOStringDate,
  getDateFromDateTimeString
} from "../../components/Utils"
import DataEditPanel, { FieldType } from "../../components/DataEditPanel"
import { IFieldValues } from "../../containers/selectionSlice"
import { cloneDeep } from "lodash"
import { format } from "date-fns"
import CustomModal from "../../components/modal"

//#endregion

enum DMPRecordsOperation {
  Add = "Add",
  Edit = "Update",
  Delete = "Delete"
}

interface PanelData {
  title: string
  values: IFieldValues
  prevValues?: IFieldValues
  CTAText: string
  operation: DMPRecordsOperation
}

interface Props {
  pageId: PageId
}

export const DisableMessageProcessing: React.FunctionComponent<Props> = ({
  pageId
}) => {
  //#region local state
  const [airportSeasons, setAirportSeasons] = useState([])
  const [airport, setAirport] = useState(null)
  const [touched, setTouched] = useState(false)
  const [invalidFieldsArr, setInvalidFieldsArr] = useState<string[]>([])
  const [selectedRowData, setSelectedRowData] = useState(null)
  const [dmpRecordsData, setDmpRecordsData] = useState(null)
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false)
  const [panelData, setPanelData] = useState<PanelData | null>(null)
  const appContext = useContext(AppContext)
  const pageConfig = getPageConfig[pageId]
  const pageTitle = pageConfig.pageTitle

  const fields = [
    {
      type: FieldType.DatePicker,
      name: FieldName.periodFromDate,
      caption: FlightText.fromDate,
      required: true
    },
    {
      type: FieldType.Time,
      name: FieldName.periodFromTime,
      caption: FlightText.fromTime,
      required: true
    },
    {
      type: FieldType.DatePicker,
      name: FieldName.periodToDate,
      caption: FlightText.toDate,
      required: true
    },
    {
      type: FieldType.Time,
      name: FieldName.periodToTime,
      caption: FlightText.toTime,
      required: true
    },
    {
      type: FieldType.CheckBoolean,
      name: FieldName.disableNew,
      caption: FlightText.disableNew
    },
    {
      type: FieldType.CheckBoolean,
      name: FieldName.disableTimeChange,
      caption: FlightText.disableTime
    },
    {
      type: FieldType.CheckBoolean,
      name: FieldName.disableAcUpgrade,
      caption: FlightText.disableAc
    }
  ]

  useEffect(() => {
    const requiredFields = fields.filter(
      (requiredField) => requiredField.required === true
    )

    const requiredFieldsNames = requiredFields.map((a) => a.name)
    const requiredFieldsObj = Object.fromEntries(
      requiredFieldsNames.map((name) => [name, panelData?.values[name]])
    )

    const inValidArray = Object.keys(requiredFieldsObj).filter(
      (requiredField) => {
        return (
          requiredFieldsObj[requiredField] === null ||
          requiredFieldsObj[requiredField] === "" ||
          error
        )
      }
    )

    setInvalidFieldsArr(inValidArray)
  }, [panelData])

  useEffect(() => {
    appContext.handleSetIsLoading({
      isLoading: true,
      loadingTxt: LoadingText.loadingAirportSeasons
    })
    getAirportSeasonConfigurations(
      pageId,
      (airportSeasons) => {
        setAirportSeasons(airportSeasons)
        appContext.handleSetIsLoading({ isLoading: false })
      },
      () =>
        appContext.handleSetIsLoading({ isLoading: false, fromFailure: true })
    )

    // eslint-disable-next-line
  }, [pageId])

  useEffect(() => {
    if (!airport && airportOpts.length) {
      setAirport(airportOpts[0].value)
    }
  }, [airportSeasons])

  useEffect(() => {
    if (airport) {
      appContext.handleSetIsLoading({
        isLoading: true,
        loadingTxt: LoadingText.recievingRecords
      })
      handleGetDMPRecords()
    }
  }, [airport])

  const handleGetDMPRecords = () => {
    getDmpRecords(
      pageId,
      { airport },
      (dmpRecords) => {
        appContext.handleSetIsLoading({ isLoading: false, fromFailure: true })
        setDmpRecordsData(dmpRecords)
      },
      () =>
        appContext.handleSetIsLoading({ isLoading: false, fromFailure: true })
    )
  }

  const handleSetDMPRecords = (operation: DMPRecordsOperation) => {
    let dmpRecords = []
    let values = cloneDeep(panelData.values)
    const _periodFromDate = getDateFromDateTimeString(
      panelData.values.periodFromDate,
      values.periodFromTime
    )
    setTouched(true)
    const _periodToDate = getDateFromDateTimeString(
      panelData.values.periodToDate,
      values.periodToTime
    )
    values.periodFrom = formatISOStringDate(_periodFromDate)
    values.periodTo = formatISOStringDate(_periodToDate)
    delete values.periodFromDate
    delete values.periodToDate
    delete values.periodFromTime
    delete values.periodToTime

    if (operation === DMPRecordsOperation.Add) {
      dmpRecords = [values]
    }

    if (operation === DMPRecordsOperation.Edit) {
      const prevValues = cloneDeep(panelData.prevValues)
      delete prevValues.periodFromDate
      delete prevValues.periodToDate
      delete prevValues.periodFromTime
      delete prevValues.periodToTime

      dmpRecords = [prevValues, values]
    }
    console.log(invalidFieldsArr)

    if (invalidFieldsArr.length === 0) {
      appContext.handleSetIsLoading({
        isLoading: true,
        loadingTxt:
          operation === DMPRecordsOperation.Edit
            ? LoadingText.editingRecord
            : LoadingText.addingRecord
      })
      setDmpRecords(
        pageId,
        { operation, dmpRecords },
        () => {
          setPanelData(null)
          handleGetDMPRecords()
        },
        () =>
          appContext.handleSetIsLoading({ isLoading: false, fromFailure: true })
      )
    }
  }

  const handleAddNew = () => {
    setTouched(false)
    setPanelData({
      title: CommonText.addNewDMPRecord,
      CTAText: BtnText.add,
      values: {
        airport,
        periodFromDate: null,
        periodToDate: null,
        periodFromTime: "",
        periodToTime: "",
        disableNew: false,
        disableAcUpgrade: false,
        disableTimeChange: false
      },
      operation: DMPRecordsOperation.Add
    })
  }

  const handleEdit = () => {
    setTouched(false)
    let prevValues = cloneDeep(selectedRowData)
    prevValues.periodFromTime = format(new Date(prevValues.periodFrom), "HHmm")
    prevValues.periodToTime = format(new Date(prevValues.periodTo), "HHmm")
    prevValues.periodFromDate = formatDate(new Date(prevValues.periodFrom))
    prevValues.periodToDate = formatDate(new Date(prevValues.periodTo))

    setPanelData({
      title: CommonText.editDMPRecord,
      CTAText: BtnText.edit,
      values: {
        airport,
        periodFromDate: prevValues.periodFromDate,
        periodToDate: prevValues.periodToDate,
        periodFromTime: prevValues.periodFromTime,
        periodToTime: prevValues.periodToTime,
        disableNew: prevValues.disableNew,
        disableAcUpgrade: prevValues.disableAcUpgrade,
        disableTimeChange: prevValues.disableTimeChange
      },
      prevValues: prevValues,
      operation: DMPRecordsOperation.Edit
    })
  }

  const handleDelete = () => {
    appContext.handleSetIsLoading({
      isLoading: true,
      loadingTxt: LoadingText.deletingRecord
    })
    setShowDeleteConfirmDialog(false)
    setDmpRecords(
      pageId,
      { operation: DMPRecordsOperation.Delete, dmpRecords: [selectedRowData] },
      handleGetDMPRecords,
      () =>
        appContext.handleSetIsLoading({ isLoading: false, fromFailure: true })
    )
  }
  const [error, setError] = useState(false)
  const handleFieldChange = (name: string, value: any, error: boolean) => {
    setTouched(false)
    setError(error)
    if (panelData) {
      const updPanelData = cloneDeep(panelData)
      updPanelData.values[name] = value
      setPanelData(updPanelData)
    }
  }

  const airportOpts: ValueLabel[] = useMemo(
    () =>
      airportSeasons
        .map((as) => as.airport)
        .filter((value, index, array) => array.indexOf(value) === index) // unique
        .map((ap) => ({ label: ap, value: ap })),
    [airportSeasons]
  )

  const columns: ColDef[] = [
    {
      headerName: FlightText.airport,
      field: "airport"
    },
    {
      headerName: FlightText.fromDate,
      field: "fromDate",
      valueGetter: (p: ValueGetterParams) =>
        formatDateShortwYear(new Date(p.data.periodFrom), true)
    },
    {
      headerName: FlightText.fromTime,
      field: "fromTime",
      valueGetter: (p: ValueGetterParams) =>
        format(new Date(p.data.periodFrom), "HHmm")
    },
    {
      headerName: FlightText.toDate,
      field: "toDate",
      valueGetter: (p: ValueGetterParams) =>
        formatDateShortwYear(new Date(p.data.periodTo), true)
    },
    {
      headerName: FlightText.toTime,
      field: "toTime",
      valueGetter: (p: ValueGetterParams) =>
        format(new Date(p.data.periodTo), "HHmm")
    },
    {
      headerName: FlightText.disableNew,
      field: "disableNew",
      valueGetter: (p: ValueGetterParams) => (p.data.disableNew ? "Yes" : "No")
    },
    {
      headerName: FlightText.disableTime,
      field: "disableTimeChange",
      valueGetter: (p: ValueGetterParams) =>
        p.data.disableTimeChange ? "Yes" : "No"
    },
    {
      headerName: FlightText.disableAc,
      field: "disableAcUpgrade",
      valueGetter: (p: ValueGetterParams) =>
        p.data.disableAcUpgrade ? "Yes" : "No"
    }
  ]

  return (
    <PageTemplate
      pageTitle={pageTitle}
      pageClassName={"ocs-disable-message-processing"}
      pageContentClassName=""
    >
      <div className="page-content-wrapper h-100p">
        <div className="ocs-w-72">
          <DropdownField
            name={FieldName.airports}
            required
            caption={FlightText.airport}
            closeOnSelect
            options={airportOpts}
            value={airport}
            onChange={(name, val) => {
              setAirport(val)
            }}
          />
        </div>
        <DataEditTableGrid
          rowData={dmpRecordsData}
          columns={columns}
          actions={[
            {
              label: BtnText.add,
              title: BtnText.add,
              onClick: handleAddNew,
              disabled: !airport || selectedRowData
            },
            {
              label: BtnText.edit,
              title: BtnText.edit,
              onClick: handleEdit,
              disabled: !selectedRowData
            },
            {
              label: BtnText.delete,
              title: BtnText.delete,
              onClick: () => setShowDeleteConfirmDialog(true),
              disabled: !selectedRowData
            }
          ]}
          onSelect={setSelectedRowData}
        />
        {panelData && (
          <DataEditPanel
            title={panelData.title}
            CTAText={panelData.CTAText}
            touched={touched}
            fields={fields}
            values={panelData.values}
            prevValues={panelData.prevValues}
            onFieldChange={handleFieldChange}
            onCTAClick={() => handleSetDMPRecords(panelData.operation)}
            onCancel={() => setPanelData(null)}
          />
        )}
      </div>
      <CustomModal
        isOpen={showDeleteConfirmDialog}
        title={CommonText.confirmDelete}
        ctaText={BtnText.delete}
        showCancel
        onCallback={handleDelete}
        onToggle={() => setShowDeleteConfirmDialog(false)}
        position="top"
        size={"sm"}
      >
        {CommonText.confirmDeleteBodyText}
      </CustomModal>
    </PageTemplate>
  )
}

